export default __webpack_public_path__ + "static/media/play-kids.8875615a.svg";